import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CardFooterComponent } from './card-footer/card-footer.component';
import { CardComponent } from './card.component';
import { CardActionsDirective } from './card-actions.directive';
import { CardMainDirective } from './card-main.directive';
import { MatRippleModule } from '@angular/material/core';
import { CardBadgeDirective } from './card-badge.directive';

const publicApi = [
  CardComponent,
  CardFooterComponent,
  CardActionsDirective,
  CardMainDirective,
  CardBadgeDirective,
];

@NgModule({
  imports: [CommonModule, MatRippleModule],
  declarations: [...publicApi, CardBadgeDirective],
  exports: [...publicApi],
})
export class CardModule {}
